var tag = document.createElement('script');
tag.src = `${process.env.playerJsUrl}/player.js`;
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

window.onload = function () {
  if (typeof onLoadPlayerAPI === 'function') {
    onLoadPlayerAPI();
  }
  window.Tutk = Tutk;
}